module.exports = __webpack_public_path__ + "media/images/home-bg-1152-8796cdd4c5b556d31a574bf302ff1b24.png";